import { getPathPrefix } from "utils/getPathPrefix";
import style from "./logo.module.css";
import tracking from "frontend/tracking";
import { isCIM } from "utils/url-utils";

export default function AppLogo({ source }: { source: string }) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    tracking.trackAnalyticsEvent("app_logo_clicked", { source });
    if (isCIM()) {
      event.preventDefault(); // Prevent the default anchor behavior
      const url = getPathPrefix("/");
      window.open(url, "_blank"); // Open in a new tab
    }
  };

  return (
    <a href={getPathPrefix("/")} className={style.logo} onClick={handleClick}>
      <img className={style.logoImage} src={getPathPrefix("/images/logo-typography.svg")} alt="workcanvas.com" />
    </a>
  );
}
